import { FC, ImgHTMLAttributes, memo } from 'react';
import cn from '../../utils/classnames';

type FontAwesomeIconProps = ImgHTMLAttributes<HTMLImageElement> & {
    name: string;
    alt?: string;
    className?: string;
    height?: number | string;
    theme?: string;
    width?: number | string;
};

const resolveIcon = (name: string, theme?: string): string | undefined => {
    try {
        const iconName = `${name}${theme ? `.${theme}` : ''}`;

        // eslint-disable-next-line global-require
        return require(`./svgs/${iconName}.svg`);
    } catch {
        return undefined;
    }
};

const FontAwesomeIcon: FC<FontAwesomeIconProps> = (props) => {
    const { className = '', name, width = 'auto', height = 14, theme, alt = '', ...rest } = props;
    const src = resolveIcon(name, theme);

    return (
        <img
            alt={alt}
            className={cn('custom-fa-icon', className, { [name]: name })}
            height={height}
            src={src}
            width={width}
            {...rest}
        />
    );
};

export default memo(FontAwesomeIcon);
